import React from "react"

const ArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M15.0533 19.7667L9.40001 14.1133C9.27504 13.9894 9.17585 13.8419 9.10816 13.6794C9.04047 13.517 9.00562 13.3427 9.00562 13.1667C9.00562 12.9906 9.04047 12.8164 9.10816 12.6539C9.17585 12.4914 9.27504 12.3439 9.40001 12.22C9.64983 11.9717 9.98777 11.8323 10.34 11.8323C10.6923 11.8323 11.0302 11.9717 11.28 12.22L16 16.94L20.72 12.22C20.9698 11.9717 21.3078 11.8323 21.66 11.8323C22.0123 11.8323 22.3502 11.9717 22.6 12.22C22.7236 12.3446 22.8214 12.4923 22.8877 12.6548C22.9541 12.8172 22.9877 12.9912 22.9867 13.1667C22.9877 13.3421 22.9541 13.5161 22.8877 13.6785C22.8214 13.841 22.7236 13.9887 22.6 14.1133L16.9467 19.7667C16.8227 19.8916 16.6753 19.9908 16.5128 20.0585C16.3503 20.1262 16.176 20.1611 16 20.1611C15.824 20.1611 15.6497 20.1262 15.4872 20.0585C15.3248 19.9908 15.1773 19.8916 15.0533 19.7667Z"
      fill="#292929"
      fillOpacity="0.54"
    />
    <rect
      x="0.5"
      y="31.5"
      width="31"
      height="31"
      rx="3.5"
      transform="rotate(-90 0.5 31.5)"
      stroke="#D2DCE3"
    />
  </svg>
)

export default ArrowIcon
